import type { QueryGetAppNetworkSettingsArgs } from '@tribeplatform/gql-client/types'

import {
  useQuery,
  type UseQueryOptions,
} from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getAppNetworkSettingsKey } from '../../utils/keys/app.key.js'

export const useAppNetworkSettings = (options: {
  variables: QueryGetAppNetworkSettingsArgs
  useQueryOptions?: UseQueryOptions<string>
}) => {
  const { variables, useQueryOptions } = options
  const { client } = useTribeClient()
  const appNetworkSettingsKey = getAppNetworkSettingsKey({ variables })

  return useQuery<string>(
    appNetworkSettingsKey,
    () => client.app.networkSettings(variables),
    useQueryOptions,
  )
}
